import { Component, OnInit, Input } from '@angular/core';
import { Media } from 'src/app/models/service/media';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from 'src/app/components/video-dialog/video-dialog.component';

@Component({
    selector: 'app-tutorial-card',
    templateUrl: './tutorial-card.component.html',
    styleUrls: ['./tutorial-card.component.scss'],
    standalone: false
})
export class TutorialCardComponent implements OnInit {

  @Input() media: Media;

  constructor(private matDialog: MatDialog) { }

  ngOnInit(): void {

  }

  openVideo(): void {
    this.matDialog.open(VideoDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      data: {
        videoHref: this.media.mediaHref
      }
    });
  }
}
